export const WALLETS_API_ENDPOINTS = {
  WALLETS: "/internal/wallets",
} as const;
